import { NEW_VERSION_AVAILABLE } from "@/events/constants";

const store = window.store;

const handleNewVersionAvailable = ({ version }) => {
  store.dispatch("version/newVersionAvailable", { version });
};

export default {
  handle(event, payload) {
    switch (event) {
      case NEW_VERSION_AVAILABLE:
        handleNewVersionAvailable(payload);
        break;
    }
  },
};
